import { attr, hasMany, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'
import placeholder from '../assets/placeholder_elementary.png'

const Package = ApplicationRecord.extend({
  static: {
    jsonapiType: 'packages',
  },
  attrs: {
    name: attr(),
    imageUrl: attr(),
    bannerUrl: attr(),
    campaign: attr(),
    season: attr(),
    slug: attr(),
    shouldShowAppointments: attr(),
    hasLimitedPoses: attr(),
    defaultBackgroundUrl: attr(),
    isSeniorPortraits: attr(),
    isSitting: attr(),
    // Is this a SPORT pricelist? Api::PackageResource answers it through
    // SportSeason.sport?, the one implementation -- `packages.season` holds
    // five legacy spellings (`sportfall2025`, a bare `sports`, a year-less
    // `sportWinter`), so a startsWith('sports') in the client would miss
    // thousands of rows.
    //
    // ⚠️ UNDECLARED UNTIL 2026-10-12, and spraypaint drops what it is not told
    // about: every `packageItem.isSport` in the picker read undefined, so the
    // sport package card's composite branch never ran once since it shipped.
    isSport: attr(),
    multiple: attr(),
    multipleSeasons: attr(),
    placeholder: attr(),
    useNewPackageBuilder: attr(),
    useNewLayout: attr(),
    category: attr(),
    softcoverYearbook: attr(),
    hardcoverYearbook: attr(),
    options: hasMany(),
    orderPackage: hasMany(),
    backgroundSet: belongsTo(),
    backgrounds: hasMany(),
    schools: hasMany(),
    packagePoses: hasMany(),
    schoolIds: attr(),
    displaySharedPoses: attr(),
    skipPastImages: attr(),
    hideCss: attr(),
    shippingPrice: attr({ persist: false }),
  },
  methods: {
    isYearbook: function () {
      return this.name && this.name.toLowerCase().includes('yearbook')
    },
    placeholderImage: function() {
      if (!this.placeholder.includes('placeholder.png')) return this.placeholder

      return placeholder
    },
  },
})

export default Package
